function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import Icon from "../elements/icon";
var func = PropTypes.func,
    string = PropTypes.string,
    bool = PropTypes.bool,
    any = PropTypes.any,
    shape = PropTypes.shape,
    arrayOf = PropTypes.arrayOf;

var MobileSheet = /*#__PURE__*/function (_React$Component) {
  _inherits(MobileSheet, _React$Component);

  var _super = _createSuper(MobileSheet);

  function MobileSheet() {
    _classCallCheck(this, MobileSheet);

    return _super.apply(this, arguments);
  }

  _createClass(MobileSheet, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        className: classNames("et--mobile-sheet", this.props.className)
      }, /*#__PURE__*/React.createElement("div", {
        className: "et--mobile-sheet--header"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "arrow-left",
        onClick: this.props.onBack
      }), /*#__PURE__*/React.createElement("span", {
        className: "et--mobile-sheet--header-label"
      }, this.props.label), function () {
        if (_this.props.headerActionLabel) {
          var action_disabled = !_this.props.onHeaderAction || _this.props.headerActionDisabled;
          return /*#__PURE__*/React.createElement("span", {
            className: classNames("et--mobile-sheet--header-action", {
              "is-disabled": action_disabled
            }),
            onClick: !action_disabled ? _this.props.onHeaderAction : undefined
          }, _this.props.headerActionLabel);
        }
      }()), /*#__PURE__*/React.createElement("div", {
        className: classNames("et--mobile-sheet--content", {
          "has-actions": this.props.actions,
          "has-wrapper": this.props.wrapContent
        }),
        style: {
          backgroundColor: this.props.backgroundColor
        }
      }, this.props.children), this.props.actions ? /*#__PURE__*/React.createElement("div", {
        className: "et--mobile-sheet--actions"
      }, function () {
        if (_this.props.actions.length === 1) {
          var action = _this.props.actions.length[0];
          return /*#__PURE__*/React.createElement("div", {
            className: "et--mobile-sheet--single-button-wrap"
          }, /*#__PURE__*/React.createElement("button", {
            className: "et--mobile-sheet--single-button",
            disabled: action.disabled,
            onClick: action.onClick
          }, action.label));
        } else {
          var number_class = function () {
            switch (_this.props.actions.length) {
              case 2:
                return "of-two";

              case 3:
                return "of-three";

              default:
                return "";
            }
          }();

          return _this.props.actions.map(function (action) {
            return /*#__PURE__*/React.createElement("button", {
              className: classNames("et--mobile-sheet--split-button", number_class, action.className),
              key: action.label,
              disabled: action.disabled,
              onClick: action.onClick
            }, action.label);
          });
        }
      }()) : undefined);
    }
  }]);

  return MobileSheet;
}(React.Component);

_defineProperty(MobileSheet, "displayName", "MobileSheet");

_defineProperty(MobileSheet, "propTypes", {
  className: string,
  label: string,
  onBack: func,
  headerActionLabel: string,
  // label on upper right of sheet header
  onHeaderAction: func,
  // no args
  wrapContent: bool,
  backgroundColor: string,
  actions: arrayOf(shape({
    className: string,
    label: any,
    onClick: func,
    disabled: bool
  }))
});

_defineProperty(MobileSheet, "defaultProps", {
  actions: []
});

export { MobileSheet as default };